module.exports = __webpack_public_path__ + "img/card-b2b.21b84ffd.svg";